module.exports = __webpack_public_path__ + "img/boky_81_temne-modra.52c2d780.png";